module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "py-1 overline grey darken-4 text white--text"
  }, [_vm._v("\n    Please confirm:\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dark": "",
      "three-line": ""
    }
  }, [(_vm.appointment) ? _c('v-list-tile', [(_vm.profilePicture) ? _c('v-list-tile-avatar', [_c('v-img', {
    attrs: {
      "src": _vm.profilePicture
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [(_vm.appointment.title) ? _c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.appointment.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.relationship) ? _c('v-list-tile-title', [_vm._v("\n          " + _vm._s(_vm.formatFullName(_vm.relationship)) + "\n          "), (_vm.practitioner) ? _c('small', [_vm._v("with " + _vm._s(_vm.formatFullName(_vm.practitioner)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-list-tile-sub-title', [(_vm.appointment.product) ? [_vm._v(_vm._s(_vm.appointment.product.title))] : _vm._e(), _vm._v(" "), (_vm.appointment.service) ? [_vm._v("@ " + _vm._s(_vm.appointment.service.title))] : _vm._e()], 2), _vm._v(" "), _c('v-list-tile-sub-title', [_c('strong', [_vm._v(_vm._s(_vm.dateformat(_vm.appointment.day)) + ".")]), _vm._v("\n          " + _vm._s(_vm.appointment.start_time) + " - " + _vm._s(_vm.appointment.end_time) + "\n        ")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-tile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.relationship && _vm.relationship.id),
      expression: "relationship && relationship.id"
    }],
    on: {
      "click": function($event) {
        _vm.confirmOptions.create_process = !_vm.confirmOptions.create_process
      }
    }
  }, [_c('v-list-tile-avatar', [_c('v-checkbox', {
    attrs: {
      "disabled": !_vm.hasContacts
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: (_vm.confirmOptions.create_process),
      callback: function($$v) {
        _vm.$set(_vm.confirmOptions, "create_process", $$v)
      },
      expression: "confirmOptions.create_process"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            Send notifications\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Send confirmation and reminders to\n            "), (_vm.appointment.client) ? _c('span', [_vm._v(" " + _vm._s(_vm.formatFullName(_vm.relationship)))]) : _c('span', [_vm._v("client")])]), _vm._v(" "), _c('v-list-tile-sub-title', [(!_vm.hasContacts) ? [_c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No contact info\n              ")], 1)] : [(_vm.clientPhoneNumber) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.clientPhoneNumber) + "\n                ")]) : _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No phone no.\n              ")], 1), _vm._v(" "), (_vm.clientEmail) ? _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.clientEmail) + "\n                ")]) : _c('v-chip', {
    staticClass: "v-chip--x-small",
    attrs: {
      "outline": "",
      "outlined": "",
      "label": "",
      "color": "warning"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editClient.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v("\n                No email\n              ")], 1)]], 2), _vm._v(" "), (_vm.isInPast && _vm.confirmOptions.create_process) ? _c('v-list-tile-sub-title', {
    staticClass: "amber px-2 caption"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Note, you've opted to send notifications, but this appointment is in the past. Are you sure?\n          ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.editClient
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.confirmOptions.create_process) ? _c('v-icon', [_vm._v("notifications_on")]) : _c('v-icon', [_vm._v("notifications_off")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-checkbox', {
    model: {
      value: (_vm.confirmOptions.recurring),
      callback: function($$v) {
        _vm.$set(_vm.confirmOptions, "recurring", $$v)
      },
      expression: "confirmOptions.recurring"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            Make this appointment repeat\n          ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Check to configure how this appointment should recur\n          ")])], 1)], 1), _vm._v(" "), (_vm.confirmOptions.recurring) ? _c('v-list-tile', [_c('v-list-tile-content', {
    staticClass: "ml-3"
  }, [_c('v-list-tile-title', {
    staticStyle: {
      "height": "32px"
    }
  }, [_vm._v("\n            Repeat\n            "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmOptions.recurrance.count--
      }
    }
  }, [_c('v-icon', [_vm._v("remove_circle")])], 1), _vm._v("\n            " + _vm._s(_vm.confirmOptions.recurrance.count) + "\n            "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmOptions.recurrance.count++
      }
    }
  }, [_c('v-icon', [_vm._v("add_circle")])], 1), _vm._v("\n            times\n          ")], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-dialog', {
    attrs: {
      "lazy": ""
    },
    model: {
      value: (_vm.recurranceIntervalPicker),
      callback: function($$v) {
        _vm.recurranceIntervalPicker = $$v
      },
      expression: "recurranceIntervalPicker"
    }
  }, [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "slot": "activator",
      "small": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("expand_more")]), _vm._v("\n              " + _vm._s(_vm.confirmOptions.recurrance.interval) + "\n            ")], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Choose an interval rate")]), _vm._v(" "), _vm._l((_vm.recurranceItems), function(item) {
    return _c('v-list-tile', {
      key: item,
      on: {
        "click": function($event) {
          _vm.confirmOptions.recurrance.interval = item;
          _vm.recurranceIntervalPicker = false
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item))])], 1)], 1)
  })], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [(_vm.confirmOptions.recurring) ? _c('v-list-tile-sub-title', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n              This will create " + _vm._s(_vm.confirmOptions.recurrance.count) + " appointments\n            ")], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-sub-title', [(_vm.confirmOptions.create_process) ? [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("notifications_on")]), _vm._v("\n                We will send a confirmation to the client now, and a reminder one day before the appointment\n              ")] : _c('span', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("notifications_off")]), _vm._v(" No notifications will be sent\n              ")], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "mb-3",
    attrs: {
      "block": "",
      "large": "",
      "loading": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit("confirm", _vm.confirmOptions)
      }
    }
  }, [_vm._v("Create")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-334fce61","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/Confirm.vue
// module id = 1384
// module chunks = 9